import { TemplateMeta } from './TemplateParts';

export default function RsvpEssencia({ data }) {
  const {
    coupleName,
    rows,
    shortPhrase,
    ctaText,
    textColor,
    textShadow,
    titleStyle,
    bodyStyle,
    isPremium
  } = data;

  return (
    <div className="absolute inset-0 p-6 flex flex-col justify-center">
      <div className="mx-auto w-full max-w-[86%] rounded-[30px] border border-white/55 bg-white/24 backdrop-blur-lg shadow-[0_20px_38px_rgba(0,0,0,0.22)] p-6 md:p-7 text-center">
        <div className="text-[11px] uppercase tracking-[0.2em] text-white/90 font-semibold">
          Confirmação de presença {isPremium ? '• Premium' : ''}
        </div>

        <h4 className="mt-3 text-[2.15rem] md:text-[2.9rem] font-bold leading-[1.04]" style={titleStyle}>
          {coupleName}
        </h4>

        <div className="mt-4">
          <TemplateMeta rows={rows} centered textColor={textColor} textShadow={textShadow} family={bodyStyle.metaFamily} tracking={bodyStyle.metaTracking} />
        </div>

        {shortPhrase ? (
          <p className="mt-5 text-sm md:text-base max-w-[90%] mx-auto" style={bodyStyle.style}>
            {shortPhrase}
          </p>
        ) : null}

        <div className="mt-6 rounded-full border border-white/45 bg-white/18 px-4 py-2 text-xs uppercase tracking-[0.14em] font-semibold" style={{ color: textColor, textShadow }}>
          {ctaText || 'Confirme sua presença'}
        </div>
      </div>
    </div>
  );
}
